import axios from 'axios';
import axiosRequestSafeConfig from './axiosRequestSafeConfig';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_EPI_CLIENT_API_URL}/api/v1/`,
  responseType: 'json',
});

instance.interceptors.request.use(axiosRequestSafeConfig);

export default instance;
